import React, { useEffect, useState } from "react";
import * as R from "ramda"
import styled from "@emotion/styled";
import AccordionItem from "./AccordionItem";

const RootDiv = styled.div([
    {
        display: "flex",
        flexDirection: "column",
        rowGap: 10,

        maxWidth: 1000,
    }
]);

interface AccordionProps<T> {
    items: T[];
    getItemHeader: (item: T, isExpanded: boolean) => JSX.Element;
    getItemContent: (item: T) => JSX.Element;
}

function Accordion<T>({ items, getItemHeader, getItemContent }: AccordionProps<T>): JSX.Element {
    const initialState: boolean[] = Array(items.length).fill(true);
    const resetState: boolean[] = Array(items.length).fill(false);
    const [isExpanded, setExpanded] = useState(initialState);

    function onClick(itemIndex: number) {
        setExpanded(oldState => R.update(itemIndex, !oldState[itemIndex], resetState));
    }

    useEffect(() => {
        // This is needed to make the accordion fully open when JavaScript is disable in the browser
        setExpanded(resetState);
    }, []);

    return (
        <RootDiv>
            {items.map((item, index) =>
                <AccordionItem key={`ai_${index}`} header={getItemHeader(item, isExpanded[index]!)} isExpanded={isExpanded[index]!} onClick={() => onClick(index)}>
                    {getItemContent(item)}
                </AccordionItem>
            )}
        </RootDiv>
    );
}

export default Accordion;
